module.exports = __webpack_public_path__ + "static/andrew_recruitment-f419a4d47918e368a7c319a5b43c4c90.jpg";